define(function(require, exports, module) {
    var Config = require('../../Config/Config');

    var search = function() {}

    search.prototype.addSearchEvent = function() {
        $("#search-2014 .form button, #nav-mygb .form button").unbind("click").bind("click", function() {
            var keyword = $(this).parent().find("input").attr("id");
            doSearch(keyword);
        });

        $("#search-2014 .form input, #nav-mygb .form input").unbind("keydown").bind("keydown", function(event) {
            if (event.keyCode == 13) {
                doSearch($(this).attr("id"));
            }
        });
    }

    function doSearch(sNodeId) {
        var sUrl, sUrl_T = "//search.jd.com/Search?keyword={keyword}&enc={enc}{additional}";
        var sAdditionalSearch = search.additinal || "";
        var oKeyTextN = document.getElementById(sNodeId);
        var sSelKeyValue = oKeyTextN.value;
        sSelKeyValue = sSelKeyValue.replace(/^\s*(.*?)\s*$/, "$1");
        if (sSelKeyValue.length > 100) {
            sSelKeyValue = sSelKeyValue.substring(0, 100);
        }
        if ("" == sSelKeyValue) {
            window.location.href = window.location.href;
            return;
        }
        var iSearchType = 0;
        if ("undefined" != typeof(window.pageConfig) && "undefined" != typeof(window.pageConfig.searchType)) {
            iSearchType = window.pageConfig.searchType;
        }
        var sCIdParamKey_T = "&cid{level}={cid}";
        var sCId = ("string" == typeof(search.cid) ? search.cid : "");
        var sCLevel = ("string" == typeof(search.cLevel) ? search.cLevel : "");
        var sEvVal = ("string" == typeof(search.ev_val) ? search.ev_val : "");
        switch (iSearchType) {
            case 8:
                sUrl_T = "//search.jd.hk/Search?keyword={keyword}&enc=utf-8";
                break;
            default:
                break;
        }
        if ("string" == typeof(sCId) && "" != sCId && "string" == typeof(sCLevel)) {
            var reLevel = /^(?:[1-8])?([1-3])$/;
            if ("-1" == sCLevel) {
                sCLevel = "";
            } else {
                if (reLevel.test(sCLevel)) {
                    sCLevel = RegExp.$1;
                } else {
                    sCLevel = "";
                }
            }
        }
        sSelKeyValue = encodeURIComponent(sSelKeyValue);
        sUrl = sUrl_T.replace(/\{keyword}/, sSelKeyValue);
        sUrl = sUrl.replace(/\{enc}/, 'utf-8');
        if (Config.isSubmited == false) {
            setTimeout(function() {
                Config.isSubmited = false;
                window.location.href = sUrl;
            }, 10);
            Config.isSubmited = true;
        }
    }

    module.exports = new search();
});



// WEBPACK FOOTER //
// ./src/js/unit/search/search.js